// extracted by css-extract-rspack-plugin
export default {"selectedItemPrefix":"Rl9sXCUCo1c_rIRM","button":"HJHj9sMK0wo3iEcb","listFooter":"jlIiwkA4IseNrpqu"};